import { render, staticRenderFns } from "./PageWrapper.vue?vue&type=template&id=ecbf04b8"
import script from "./PageWrapper.vue?vue&type=script&lang=js"
export * from "./PageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports